import React from 'react';
import { FadeIn, Section } from './Shared';
import { Gift } from 'lucide-react';
export const BonusSection = () => {
  const bonuses = ['Lista de supermercado lista para usar', 'Guía de alimentos permitidos y prohibidos', 'Checklist diario de seguimiento'];
  return <Section bg="teal" className="text-white" data-id="element-25">
      <FadeIn data-id="element-26">
        <div className="text-center mb-8" data-id="element-27">
          <div className="inline-flex items-center justify-center w-14 h-14 bg-white/10 rounded-full mb-4" data-id="element-28">
            <Gift className="w-8 h-8 text-brand-yellow" data-id="element-29" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold font-heading" data-id="element-30">
            Incluye además:
          </h2>
        </div>
      </FadeIn>

      <div className="max-w-3xl mx-auto grid sm:grid-cols-3 gap-6" data-id="element-31">
        {bonuses.map((bonus, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-32">
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl border border-white/20 h-full text-center hover:bg-white/15 transition-colors" data-id="element-33">
              <p className="text-lg font-medium" data-id="element-34">{bonus}</p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};